package org.dronda.app.web.repository

import com.github.michaelbull.result.Result
import org.dronda.api.wishlist.Group
import org.dronda.app.web.client.GroupClient

class GroupRepository(
    private val groupClient: GroupClient
) {

    suspend fun getGroups(): Result<List<Group>, Unit> {
        return groupClient.getGroups()
    }
}
